import * as React from "react";
import useHasAccessToAnyStream from "hooks/useHasAccessToAnyStream";
import UserHasNoStreamAccess from "pages/UserHasNoStreamAccess";
export default ({ children, skipNoStreamsCheck = false }) => {
  const hasAccessToAnyStream = useHasAccessToAnyStream();
  if (skipNoStreamsCheck) {
    return children;
  }
  return hasAccessToAnyStream ? children : /* @__PURE__ */ React.createElement(UserHasNoStreamAccess, null);
};
